<template>
    <div :class="['detail-schedule-container', styleTheme]">
        <section class="table-schedule" v-if="!success">
            <div class="schedule-top-bar"></div>
            <Offer
                v-if="showMakeOffer"
                :additionalTitle="additionalTitle"
                @onSuccess="onSuccess"
                @onPopRegister="onPopRegister"
            ></Offer>
            <Appointment
                v-else
                :inPop="inPop"
                :apptTitle="apptTitle"
                :apptSubTitle="apptSubTitle"
                :apptSubmitText="apptSubmitText"
                :apptQuestionMsg="apptQuestionMsg"
                :swiperConfig="swiperConfig"
                @onSuccess="onSuccess"
                @onPopRegister="onPopRegister"
            ></Appointment>
        </section>
        <section class="tab-success" v-else>
            <AppointmentSuccess
                v-if="showMakeOffer"
                :isOffer="showMakeOffer"
                :agentInfo="agentInfo"
                :firsttext="$t('md-detail-info.wellBeInTouch')"
                :title="$t('md-detail-info.yourOfferPriceIsReceived')"
                :text="$t('md-detail-info.wellBeInTouchSoon')"
                :buttonText="$t('md-detail-info.reviseOfferDetails')"
            />
            <AppointmentSuccess
                v-else
                :agentInfo="agentInfo"
                :isOffer="showMakeOffer"
                :title="$t('md-detail-info.yourRequestWasReceived')"
                :text="$t('md-detail-info.weWillConfirmMeeting')"
                :buttonText="$t('md-detail-info.scheduleAgain')"
            />
        </section>
        <template v-if="(!inPop || isMobileSize) && mlsShowAgent">
            <agent-info v-if="agentInfo" v-bind="agentInfo" />
            <template v-for="(colAgent, index) in coAgentInfo" :key="index">
                <agent-info v-bind="colAgent" />
            </template>
        </template>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { useUserStore } from '@/store';
import Appointment from './schedule-appointment.vue';
import AppointmentSuccess from './schedule-success.vue';
import Offer from './schedule-offer.vue';
import AgentInfo from './agentInfo';
import { schedule } from './schedule.js';
export default {
    props: {
        extData: {
            type: Object,
            default: undefined
        },
        isMobileSize: {
            type: Boolean,
            default: false
        }
    },
    mixins: [schedule],
    watch: {
        user(value) {
            if (!value) {
                this.updateScheduleTour({ success: false });
            }
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            info: store => store.listingDetail.info || {},
            pricePerMonth: store => store.pricePerMonth,
            infoFlag: store => store.infoFlag
        })
    },
    methods: {
        ...mapActions({
            updateScheduleTour: 'updateScheduleTour'
        })
    },

    components: {
        Appointment,
        AppointmentSuccess,
        Offer,
        AgentInfo
    }
};
</script>

<style lang="scss">
@import '../../theme/mixin.scss';
@import '../../theme/media.scss';
.detail-schedule-container {
    padding: 30px;
    font-size: 14px;
    border: 1px solid rgba(218, 218, 218, 0.5);
    background-color: var(--g-bg-color);
    &.fashion {
        --g-bg-color: #1d2231;
        --g-primary-color: #fff;
        --g-text-color: rgba(255, 255, 255, 0.8);
        border: 1px solid var(--g-bg-color);
    }
    .header {
        padding: 30px 0;
        text-align: center;
        border: 1px solid #e9eaee;
        border-bottom: none;
        background-color: white;
        .nodisclosure {
            justify-content: center;
            margin-bottom: 20px;
            .dollar {
                font-size: 36px;
                line-height: normal;
            }
            .secret {
                font-size: 25px;
            }
            .des {
                font-size: 14px;
            }
        }
        .title {
            line-height: 20px;
            height: 20px;
            border-radius: 2px;
            text-transform: capitalize;
            color: #515666;
            background-color: rgba(81, 86, 102, 0.1);
            padding: 0 5px;
            font-size: 12px;
            display: inline-block;
            &.openhouse {
                background-color: rgba(69, 173, 255, 0.1);
                color: #45adff;
            }
            &.hot {
                background-color: rgba(240, 82, 82, 0.1);
                color: #f05252;
            }
            &.new {
                background-color: rgba(98, 178, 128, 0.1);
                color: #62b280;
            }
            &.reduced {
                background-color: rgba(239, 120, 79, 0.1);
                color: #ef784f;
            }
            &.active {
                background-color: rgba(187, 64, 239, 0.1);
                color: #bb40ef;
            }
        }
        .price {
            height: 40px;
            font-size: 36px;
            color: #202437;
            margin: 15px 0 15px;
            font-family: var(--font-bold);
        }
    }
}
</style>
